import axios from "axios";
import Toast from "vant/lib/toast";
export async function eshiminConfig() {
  const res = await axios.post('/forwarder/login/fetchEshiminToken', {})
  if (res.status === 200) {
    let accessToken = res.data
    // 第⼀时间注⼊权限配置
    // eslint-disable-next-line no-undef
    eshimin.config({
      debug: true,
      signature: accessToken,
      jsApiList: ['openService']
    })
    // eslint-disable-next-line no-undef
    eshimin.ready(function () {
      console.log("市民云注入成功")

    })
    // eslint-disable-next-line no-undef
    eshimin.error(function (message) {
      console.log("message====="+message)
      Toast(message)
    })
  } else {
    // console.log(res.data)
    // Toast(res.data.msg)
  }
  // console.log('------created eshiminConfig结束执行状态------');

}
export function eshiminOpenService(serviceCode) {
  eshiminInvoke('openService', {serviceCode : serviceCode})
}
export function eshiminInvoke(ability,parameter) {
  eshimin.invoke(
    ability,
    parameter,
    function (response) {
      var success = response.errorCode === 0
      if (!success) {
        Toast(response.errorCode + ':' + response.errorMessage)
      }
    })
}
